export enum PlacementOptionsActionTypes {
  PLACEMENT_OPTIONS_FETCH_SUCCESS = "PLACEMENT_OPTIONS_FETCH_SUCCESS",
  PLACEMENT_OPTIONS_FETCH_ERROR = "PLACEMENT_OPTIONS_FETCH_ERROR",
  PLACEMENT_OPTIONS_RESET_STATE = "PLACEMENT_OPTIONS_RESET_STATE",
  PLACEMENT_OPTIONS_SET_SELECTED_PLACEMENT_OPTION_ID = "PLACEMENT_OPTIONS_SET_SELECTED_PLACEMENT_OPTION_ID",
  PLACEMENT_OPTIONS_RESET_SINGLE_PLACEMENT_OPTION = "PLACEMENT_OPTIONS_RESET_SINGLE_PLACEMENT_OPTION",
}
